import { Navigate, Outlet } from "react-router-dom";
import { Authen } from "../Services/Middleware/authen";
import authService from "../Services/auth.service";

const ProtectedRoutes = () => {
  const isAuth = Authen();

  let user = authService.auth();

  let url = "/lab";

  if (user && user.group_id === "4") {
    url = "/login/line";
  }

  return isAuth ? <Navigate to={url} /> : <Outlet />;
};

export default ProtectedRoutes;
